export default {
    "recipes": "b0be8cf71c7773fd31a96d3f3950b53d7561e0a5ac05ddc706cc8f0ec5eff84e"
};
